module.exports = __webpack_public_path__ + "img/50.2f843ad3.jpg";